// For use with Alpine 3.13.x
(function () {
  /**
   * Formats money to 2 decimal places, or truncates all decimals if they're zero
   * @param {Element} el
   * @param {*} param1
   * @param {*} param2
   */
  function moneyDirective(el, { expression }, { evaluateLater, effect }) {
    let expEvaluate = evaluateLater(expression);

    effect(() => {
      expEvaluate((exp) => {
        let num = Number(exp);

        num /= 100;

        if (num <= 0) {
          el.textContent = "FREE";
        }

        if (Number.isInteger(num)) {
          el.textContent = "$" + Math.trunc(num);
        } else {
          el.textContent = "$" + num.toFixed(2);
        }
      });
    });
  }

  /**
   * Hijacks the add to cart form submission and progressively enhances it
   * @param {Element} el
   * @param {*} param1
   * @param {*} param2
   */
  function enhanceCartAddDirective(el, {}, { cleanup, evaluateLater, effect }) {
    /**
     * @param {Event} event
     */
    function handler(event) {
      event.preventDefault();

      const formData = new FormData(event.target);

      let variantId = formData.get("id");
      if (variantId == null) {
        console.error('Cart enhance failed due to missing "id" form input');
        return;
      }
      variantId = Number(variantId);

      let addQty = formData.get("quantity");
      if (addQty == null) {
        console.error('Cart enhance failed due to missing "quantity" form input');
        return;
      }
      addQty = Number(addQty);

      let currentQty = window.cart.items.find((item) => item.variant_id === variantId)?.quantity ?? 0;

      // Update cart, window.cart and the cart store
      fetch((window.Shopify?.routes?.root ?? "/") + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {
            [variantId]: addQty + currentQty,
          },
        }),
      })
        .then((rawResp) => {
          rawResp.json().then((jsonResp) => {
            window.cart = jsonResp;
            Alpine.store("cart").cart = jsonResp;
          });
        })
        .catch((error) => {
          console.error("Error enhancing cart add:", error);
        });
    }

    el.addEventListener("submit", handler);

    cleanup(() => {
      el.removeEventListener("submit", handler);
    });
  }

  /**
   * Hijacks the click on <a> and progressively enhances it if it's a fragment link.
   * This is solely used to update :target without the page scroll jumping.
   * The expression is evaluated every click event.
   * @param {Element} el
   * @param {*} param1
   * @param {*} param2
   */
  function enhanceFragmentHref(el, { expression }, { cleanup, evaluateLater, effect }) {
    /**
     * @param {Event} event
     */
    function handler(event) {
      if (!el.href.includes("#")) {
        return;
      }

      event.preventDefault();

      window.addEventListener(
        "popstate",
        () => {
          history.forward();
        },
        { once: true }
      );
      history.pushState({}, "", el.href);
      history.back();

      expEvaluate();
    }

    let expEvaluate = expression ? evaluateLater(expression) : () => {};

    el.addEventListener("click", handler);

    cleanup(() => {
      el.removeEventListener("click", handler);
    });
  }

  /**
   * Detects a click outside a dialog, then closes said dialog.
   * @param {Element} el
   * @param {*} param1
   * @param {*} param2
   */
  function dialogBackdropClose(el, {}, { cleanup }) {
    /**
     * @param {Event} event
     */
    function handler(event) {
      if (event.pointerType !== "mouse") {
        return;
      }

      let rect = el.getBoundingClientRect();

      let isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!isInDialog) {
        el.close();
      }
    }

    el.addEventListener("click", handler);

    cleanup(() => {
      el.removeEventListener("click", handler);
    });
  }

  function extendAlpineDirectives() {
    Alpine.directive("money", moneyDirective);
    Alpine.directive("enhance-cartadd", enhanceCartAddDirective);
    Alpine.directive("enhance-fragment-href", enhanceFragmentHref);
    Alpine.directive("dialog-backdrop-close", dialogBackdropClose);

    document.removeEventListener("alpine:init", extendAlpineDirectives);
  }

  document.addEventListener("alpine:init", extendAlpineDirectives);
})();
